:host {
    @include grid;

    .main-content-container {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: var(--column-gap);
        align-items: flex-end;
        padding: 48px 0 60px;
    }

    p {
        @include typo-ws-paragraph-bold;

        grid-row: 1;
        grid-column: 1 / -1;
        margin: 0;
        margin-bottom: 36px;
    }

    sew-combobox,
    sew-ws-button {
        grid-row: 2;
        min-width: 0;
        min-height: 0;
    }

    sew-combobox {
        --label-color: #{$color-grey-01-dark};
    }
}

@include mq-1 {
    :host {
        .main-content-container {
            grid-template-columns: 1fr;
            padding: 40px 0;
        }

        p {
            margin-bottom: 24px;
        }

        sew-combobox,
        sew-ws-button {
            margin-top: 20px;
            grid-column: 1;
            grid-row: auto;
        }

        sew-combobox:first-of-type {
            margin-top: 0;
        }

        sew-ws-button {
            margin-top: 40px;
        }
    }
}
